export default "__VITE_ASSET__75973eec__"